import axiosInstance from './axiosConfig';
import { API_URLS } from './config';

interface TranslationResponse {
  status: string;
  translation: {
    translated_text: string;
  };
}

export const translateText = async (
  text: string,
  targetLanguage: string
): Promise<string> => {
  try {
    const response = await axiosInstance.post<TranslationResponse>(API_URLS.translate, {
      text,
      target_language: targetLanguage,
    });
    return response.data.translation.translated_text;
  } catch (error) {
    console.error('Translation API error:', error);
    throw new Error('Translation failed');
  }
};
